module.exports = __webpack_public_path__ + "static/media/018_dashboard_v1.a8e86c6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/docker/018_dashboard_v1.png
// module id = 397
// module chunks = 0